// Comprehensive list of Pakistani cities and towns (200+).
// Grouped by province for the optgroups; users see them alphabetically inside each group.
// Source: official census + administrative units. If a panelist's city is missing,
// they pick "Other" and type it manually — the value is still stored as the typed string.

export const PAKISTAN_CITIES = {
  Punjab: [
    "Ahmedpur East", "Arifwala", "Attock", "Bahawalnagar", "Bahawalpur", "Bhakkar",
    "Bhalwal", "Burewala", "Chakwal", "Chiniot", "Chichawatni", "Chishtian",
    "Daska", "Dera Ghazi Khan", "Dunyapur", "Faisalabad", "Fateh Jang", "Ferozewala",
    "Gojra", "Gujranwala", "Gujrat", "Hafizabad", "Haroonabad", "Hasilpur",
    "Haveli Lakha", "Jalalpur Jattan", "Jampur", "Jaranwala", "Jhang", "Jhelum",
    "Kabirwala", "Kahror Pakka", "Kamalia", "Kamoke", "Karor Lal Esan", "Kasur",
    "Khanewal", "Khanpur", "Kharian", "Khushab", "Kot Adu", "Lahore",
    "Lalamusa", "Layyah", "Liaquatpur", "Lodhran", "Mailsi", "Mandi Bahauddin",
    "Mian Channu", "Mianwali", "Multan", "Murree", "Muzaffargarh", "Nankana Sahib",
    "Narowal", "Okara", "Pakpattan", "Pattoki", "Pind Dadan Khan", "Pir Mahal",
    "Quaidabad", "Rahim Yar Khan", "Raiwind", "Rajanpur", "Rawalpindi", "Renala Khurd",
    "Sadiqabad", "Safdarabad", "Sahiwal", "Sambrial", "Sangla Hill", "Sargodha",
    "Sheikhupura", "Shujabad", "Sialkot", "Talagang", "Taunsa Sharif", "Toba Tek Singh",
    "Vehari", "Wah Cantonment", "Wazirabad", "Yazman", "Zafarwal"
  ],
  Sindh: [
    "Badin", "Bhit Shah", "Dadu", "Dharki", "Digri", "Diplo",
    "Ghotki", "Hala", "Hyderabad", "Islamkot", "Jacobabad", "Jamshoro",
    "Jati", "Jhuddo", "Kambar", "Karachi", "Kashmore", "Khairpur",
    "Khairpur Mir's", "Khairpur Nathan Shah", "Kotri", "Kunri", "Larkana", "Matiari",
    "Matli", "Mehar", "Mirpur Khas", "Mirpur Mathelo", "Mithi", "Moro",
    "Nagarparkar", "Nawabshah", "Naushahro Feroze", "Pano Aqil", "Qambar", "Ranipur",
    "Ratodero", "Rohri", "Sakrand", "Sanghar", "Sehwan", "Shahdadkot",
    "Shahdadpur", "Shikarpur", "Sukkur", "Tando Adam", "Tando Allahyar", "Tando Jam",
    "Tando Muhammad Khan", "Tangwani", "Tharparkar", "Thatta", "Ubauro", "Umerkot"
  ],
  "Khyber Pakhtunkhwa (KPK)": [
    "Abbottabad", "Akora Khattak", "Banda Daud Shah", "Bannu", "Barikot", "Batkhela",
    "Battagram", "Bhera", "Buner", "Chakdara", "Charsadda", "Chitral",
    "Daggar", "Dargai", "Dassu", "Dera Ismail Khan", "Dir", "Doaba",
    "Hangu", "Haripur", "Karak", "Kohat", "Kulachi", "Lakki Marwat",
    "Lower Dir", "Malakand", "Mansehra", "Mardan", "Mingora", "Nowshera",
    "Paharpur", "Parachinar", "Peshawar", "Risalpur", "Saidu Sharif", "Shabqadar",
    "Shangla", "Swabi", "Swat", "Takht-i-Bahi", "Tank", "Thall",
    "Timergara", "Tordher", "Upper Dir"
  ],
  Balochistan: [
    "Awaran", "Barkhan", "Chagai", "Chaman", "Dalbandin", "Dera Allahyar",
    "Dera Bugti", "Dera Murad Jamali", "Dukki", "Gandava", "Gwadar", "Harnai",
    "Hub", "Jaffarabad", "Jhal Magsi", "Kalat", "Kech (Turbat)", "Kharan",
    "Khuzdar", "Killa Abdullah", "Killa Saifullah", "Kohlu", "Lasbela", "Loralai",
    "Mach", "Mastung", "Musakhel", "Nasirabad", "Nushki", "Ormara",
    "Panjgur", "Pasni", "Pishin", "Quetta", "Sherani", "Sibi",
    "Sohbatpur", "Surab", "Turbat", "Uthal", "Washuk", "Zhob",
    "Ziarat"
  ],
  "Islamabad / Gilgit-Baltistan / AJK": [
    "Astore", "Bagh", "Bhimber", "Chilas", "Diamer", "Gakuch",
    "Gilgit", "Ghanche", "Ghizer", "Gupis", "Hunza", "Islamabad",
    "Kel", "Khaplu", "Kotli", "Mirpur (AJK)", "Muzaffarabad", "Nagar",
    "Pallandri", "Rawalakot", "Shigar", "Skardu", "Sost", "Sudhanoti"
  ],
};

// Flattened, alphabetically sorted, de-duplicated list (used for searchable dropdown).
export const ALL_PAKISTAN_CITIES = Array.from(
  new Set(Object.values(PAKISTAN_CITIES).flat())
).sort((a, b) => a.localeCompare(b));

export const CITY_OTHER_VALUE = "__other__";
